import { StateMethods } from '@hookstate/core';
import { format } from 'date-fns';
import { Dispatch, SetStateAction } from 'react';

import CheckboxIcon from '@assets/svg/checkbox-checked.svg';

import { Tag as TagComponent } from '@components/Tag/Tag';
import { ITag } from '@models/Tag.model';
import { ITagCategory } from '@models/TagCategory.model';
import { TagsMenu } from '../TagsMenu/TagsMenu';

import {
  Checkbox,
  Container,
  Item,
  LineDivider,
  MenuDiv,
  TagWrapper,
  Text,
} from './TagRow.styles';

interface ITagRow {
  isManage: boolean;
  tags: ITag;
  tagCategory: ITagCategory;
  toggleCheckBox: (id: string) => void;
  isChecked: boolean;
  setOpenMoveTagDialog: Dispatch<SetStateAction<boolean>>;
  setTagId: Dispatch<SetStateAction<string[]>>;
  openDeleteTagDialog: StateMethods<boolean>;
  toggleSelectedTags: (Tag: ITag) => void;
}

const TagRow = ({
  isManage,
  tags,
  toggleCheckBox,
  tagCategory,
  isChecked,
  openDeleteTagDialog,
  setTagId,
  setOpenMoveTagDialog,
  toggleSelectedTags,
}: ITagRow) => {
  return (
    <Container>
      <>
        <Item grid={!isManage}>
          {!isManage ? (
            <Checkbox
              onClick={() => {
                toggleCheckBox(tags.id);
                toggleSelectedTags(tags);
              }}
              checked={isChecked}
            >
              {isChecked ? (
                <img src={CheckboxIcon} alt="" width="14px" height="14px" />
              ) : (
                ''
              )}
            </Checkbox>
          ) : (
            ''
          )}
          <TagWrapper>
            <TagComponent
              id={tags.id}
              tagName={tags.name}
              tagCategory={tagCategory.name}
              color={tagCategory.color}
            />
          </TagWrapper>

          {tags.description ? (
            <Text light limitOfLines={1}>
              {tags.description}
            </Text>
          ) : (
            <Text className="noDescription">No description</Text>
          )}

          <Text light limitOfLines={1}>
            {tags.lastUsed && format(tags.lastUsed, 'MM/dd/yyyy')}
          </Text>

          <Text light limitOfLines={1} className="numberOfItems">
            {tags.equipmentsCount}
          </Text>
          <MenuDiv>
            <TagsMenu
              setTagId={setTagId}
              tags={tags}
              setOpenMoveTagDialog={setOpenMoveTagDialog}
              openDeleteTagDialog={openDeleteTagDialog}
            />
          </MenuDiv>
        </Item>
        <LineDivider />
      </>
    </Container>
  );
};

export { TagRow };
